<template>
  <div class="fm-app">
    <!-- ── Slim accent bar ── -->
    <div class="fm-app__topbar"/>

    <!-- ── Page header ── -->
    <header class="fm-app__header">
      <div class="fm-app__header-text">
        <h1 class="fm-app__title">Verify it's you</h1>
        <p class="fm-app__subtitle">A one-time passcode is required to continue your application.</p>
      </div>
    </header>

    <div class="fm-app__container">
      <div class="fm-card">
        <div class="fm-card__body">

          <div class="fm-info-banner mb-4">
            <svg fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
            <span>Choose how you'd like to receive your one-time passcode (OTP).</span>
          </div>

          <FormGroup label="Verification method" class="mb-4">
            <RadioButtonGroup v-model="mode" :block="true" :options="{email: 'Email', phone: 'Phone'}" size="sm"/>
          </FormGroup>

          <EmailVerification v-if="mode === 'email'" @verified="verified"/>
          <PhoneVerification v-else @verified="verified"/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormGroup from '@modules/shared/components/form/FormGroup';
import RadioButtonGroup from '@modules/shared/components/form/RadioButtonGroup';
import EmailVerification from './components/EmailVerification';
import PhoneVerification from './components/PhoneVerification';
import store, {dispatch} from '@modules/guest/new-applicant/store/store';
import {NEW_APPLICATION} from '@store/constants';

export default {
  name: 'OTPVerification',
  components: {
    PhoneVerification,
    EmailVerification,
    FormGroup,
    RadioButtonGroup
  },
  computed: {
    code() {
      return store.state[NEW_APPLICATION.MODULE_NAME].code;
    },
  },
  data() {
    return {
      mode: 'email',
    }
  },
  methods: {
    verified() {
      dispatch({ type: NEW_APPLICATION.ACTIONS.SET_CODE, payload: this.code });
    }
  }
};
</script>

<style lang="scss">
// Matches the fm-info-banner defined in BankingInformation.vue exactly —
// duplicated here rather than shared because each new-applicant step
// declares it in its own non-scoped <style> block (same existing pattern
// in this module, e.g. BankingInformation.vue).
.fm-info-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #EFF6FF;
  border: 1px solid rgba(59, 130, 246, 0.25);
  border-radius: 10px;
  font-size: 13.5px;
  color: #1d4ed8;

  svg { flex-shrink: 0; width: 16px; height: 16px; }
}
</style>
